export default "__VITE_PUBLIC_ASSET__f92dca26__"